import React from 'react'
import Gallery from '../components/Gallery'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div>
  <div className="section">
    <p className="is-size-4">Welcome to my online gallery of art. I am  delighted that you are interested in my work. All paintings displayed in the galleries below are available for sale. Click on the image to find out more about the work; dimensions, title and pricing. <Link to="/contact">Requests for commissions are also welcome.</Link></p>
  </div>
  <div className="section">
    <Gallery 
    galleryName='gallery-1'
    galleryDesc="The first selection of paintings featured is part of an ongoing series called 'Garden Gnomes'. Some of the themes captured in these images address current environmental stories. The results are colourful, gestural bodies caught in fragile, whimsical situations that draw attention to serious events such as the troubling plight of bees in ‘Just the Bee’s Knees’." 
    galleryTitle="Garden Gnomes"
    
    />
    <Gallery 
      galleryName='gallery-2' 
      galleryTitle="At One With Nature" 
      galleryDesc="The second gallery called ‘At One with Nature’ asks about humanity’s interaction with the natural landscape, spiritually, physically, and ethically. ’Tossing Rocks’ depicts two figures effortlessly throwing a boulder symbolizing humankind’s drive to manipulate the environment without anticipating a dangerous outcome. More like large scale drawings, this body of work radiates a bold, youthful exuberance because of Sherry’s technique of applying vivid colours with long, linear, gestural strokes."
      />
  </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js